import { productValidate } from '../../application/dtos/product_validate'

export class productEntity {
    constructor({id, sku, description, storage_policy, weight, is_national, unit, barcode, height, length, width, size_unit, category, client, detailed_stock, image}){
        this.id = id;
        this.sku =  sku;
        this.description = description;
        this.storage_policy = storage_policy;
        this.weight = weight;
        this.is_national = is_national;
        this.unit = unit;
        this.barcode = barcode;
        this.height = height;
        this.length = length;
        this.width = width;
        this.size_unit = size_unit;
        this.category = category;
        this.client = client;
        this.detailed_stock = detailed_stock;
        this.image = image;
    }

    isValid() {
        // return this.name && this.price >= 0;
        return productValidate(this);
    }
}